import React from 'react';
import Api from '../Api';

class AlertNotificationsConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertsEnabled: true,
    };
    this.handleDisableAlerts = this.handleDisableAlerts.bind(this);
    this.handleEnableAlerts = this.handleEnableAlerts.bind(this);
  }

  componentWillMount() {
    Api.isAlertNotificationsEnabled()
      .then((obj) => {
        this.setState({ alertsEnabled: obj.enabled });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleDisableAlerts() {
    Api.disableAlertNotifications().then((obj) => {
      console.log(obj);
      this.setState({ alertsEnabled: obj.enabled });
    });
  }

  handleEnableAlerts() {
    Api.enableAlertNotifications().then((obj) => {
      console.log(obj);
      this.setState({ alertsEnabled: obj.enabled });
    });
  }

  render() {
    const { alertsEnabled } = this.state;
    const { isSuperUser } = this.props;

    if (!isSuperUser) {
      return <div />;
    }

    return (
      <div style={{ padding: '20px' }}>
        <div style={{ marginBottom: 10 }}>
          Offline, No-Sale Alerts:
          <strong>{alertsEnabled ? ' Enabled' : ' Disabled'}</strong>
        </div>
        <button
          disabled={alertsEnabled}
          style={{ opacity: alertsEnabled ? 0.2 : 1, marginRight: 10 }}
          onClick={this.handleEnableAlerts}
        >
          Enable
        </button>
        <button
          disabled={!alertsEnabled}
          style={{ opacity: !alertsEnabled ? 0.2 : 1 }}
          onClick={this.handleDisableAlerts}
        >
          Disable
        </button>
      </div>
    );
  }
}

export default AlertNotificationsConfig;



// WEBPACK FOOTER //
// ./src/components/AlertNotificationsConfig.js